import React, { createContext, useContext, useMemo, useState } from "react";
import { INITIAL_RCC_INDICATORS } from "data/rccIndicators";

const RccIndicatorCatalogContext = createContext(null);

export function RccIndicatorCatalogProvider({ children }) {
  const [indicators, setIndicators] = useState(INITIAL_RCC_INDICATORS);

  const contextValue = useMemo(
    () => ({
      indicators,
      setIndicators,
    }),
    [indicators],
  );

  return (
    <RccIndicatorCatalogContext.Provider value={contextValue}>
      {children}
    </RccIndicatorCatalogContext.Provider>
  );
}

export function useRccIndicatorCatalog() {
  const context = useContext(RccIndicatorCatalogContext);

  if (!context) {
    throw new Error("useRccIndicatorCatalog must be used within RccIndicatorCatalogProvider");
  }

  return context;
}
